(function () {
  'use strict';

  var AUTO_ADVANCE_MS = 3500;

  // Three separate ideas, kept separate on purpose:
  //   autoplay — what the shopper (or prefers-reduced-motion) asked for.
  //   holds    — transient reasons not to move right now: the pointer or the
  //              keyboard is inside the carousel, the section is offscreen, or
  //              the tab is hidden. Named flags rather than a counter, because
  //              mouseenter/focusin pairs do not always balance.
  //   timer    — the interval, which exists only when autoplay and no holds.
  // The previous build had only `stop()`, which cleared the interval with no
  // way back: one mouseenter killed the carousel for the life of the page, and
  // there was no user-operable pause at all (WCAG 2.2 SC 2.2.2, Level A).
  function initCarousels() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-btfp-carousel]').forEach(function (carousel) {
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('.lt-btfp__carousel-img'));
      var previous = carousel.querySelector('[data-btfp-carousel-prev]');
      var next = carousel.querySelector('[data-btfp-carousel-next]');
      var toggle = carousel.querySelector('[data-btfp-carousel-toggle]');
      var toggleIcon = carousel.querySelector('[data-btfp-carousel-toggle-icon]');
      var status = carousel.querySelector('[data-btfp-carousel-status]');
      var holds = { pointer: false, focus: false, offscreen: false, hidden: false };
      var index = 0;
      var timer = null;
      var autoplay = !reduced && slides.length > 1;
      if (!slides.length) return;
      carousel.dataset.enhanced = 'true';

      // Slides 2..N ship with `data-src`/`data-srcset` and no `src` (see
      // lt-btfp-page.liquid). loading="lazy" cannot defer them: lt-btfp.css
      // stacks every slide as position:absolute/inset:0 inside one box that is
      // already in the viewport, so every photo in both carousels was fetched
      // on first paint. display:none is not an alternative — it breaks the
      // opacity crossfade this carousel is built on.
      function hydrate(i) {
        var slide = slides[i];
        if (!slide || !slide.dataset.src) return;
        if (slide.dataset.srcset) {
          slide.srcset = slide.dataset.srcset;
          slide.removeAttribute('data-srcset');
        }
        slide.src = slide.dataset.src;
        slide.removeAttribute('data-src');
      }
      // Warm the frame the timer is about to reveal, so an auto-advance never
      // lands on an empty slide. Only while it is actually running: a paused,
      // offscreen or reduced-motion carousel never fetches a photo the shopper
      // has not asked to see.
      function warm() { if (timer) hydrate((index + 1) % slides.length); }

      function render() {
        hydrate(index);
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
        if (status) status.textContent = (index + 1) + ' / ' + slides.length;
        warm();
      }
      function move(direction) { index = (index + direction + slides.length) % slides.length; render(); }
      function held() { return holds.pointer || holds.focus || holds.offscreen || holds.hidden; }
      function sync() {
        var running = autoplay && !held();
        if (running && !timer) timer = window.setInterval(function () { move(1); }, AUTO_ADVANCE_MS);
        if (!running && timer) { window.clearInterval(timer); timer = null; }
        if (toggle) {
          // A play/pause control names the ACTION it performs and swaps that
          // name with the state. aria-pressed is deliberately absent: pairing
          // it with a label that also changes tells a screen-reader user two
          // contradictory things about the same button.
          toggle.setAttribute('aria-label', autoplay ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
          // U+275A HEAVY VERTICAL BAR and U+25BA BLACK RIGHT-POINTING POINTER:
          // both are plain dingbats with no emoji presentation, so they render
          // as flat glyphs in the navy chip rather than a colour emoji.
          if (toggleIcon) toggleIcon.textContent = autoplay ? '❚❚' : '►';
        }
        // The slide counter must not announce on every automatic rotation — it
        // would interrupt continuously — but it must announce once the shopper
        // has taken control.
        if (status) status.setAttribute('aria-live', running ? 'off' : 'polite');
        warm();
      }
      function hold(name, value) { holds[name] = value; sync(); }

      if (previous) previous.addEventListener('click', function () { autoplay = false; move(-1); sync(); });
      if (next) next.addEventListener('click', function () { autoplay = false; move(1); sync(); });
      if (toggle) toggle.addEventListener('click', function () {
        if (slides.length > 1) autoplay = !autoplay;
        sync();
      });
      carousel.addEventListener('mouseenter', function () { hold('pointer', true); });
      carousel.addEventListener('mouseleave', function () { hold('pointer', false); });
      // The toggle is exempt from the focus hold, and that exemption is the
      // whole reason Play works. A real browser focuses a <button> on
      // mousedown and leaves it focused after the click, so counting the
      // toggle as a hold made the shopper's own press of Play the reason Play
      // could not start: the label flipped to "Pause" while the timer stayed
      // cleared, and a keyboard-only shopper could never restart the carousel
      // at all. Every other focusable child (prev/next) still pauses on focus.
      carousel.addEventListener('focusin', function (event) { if (event.target !== toggle) hold('focus', true); });
      carousel.addEventListener('focusout', function (event) { if (event.target !== toggle) hold('focus', false); });
      document.addEventListener('visibilitychange', function () { hold('hidden', document.hidden === true); });
      if (window.IntersectionObserver) {
        // Default state is "on screen". If the observer never fires (headless
        // renderer, hidden tab, script error) the carousel keeps working
        // instead of freezing — the same rule lt-portfolio.liquid documents.
        new window.IntersectionObserver(function (entries) {
          hold('offscreen', entries[entries.length - 1].isIntersecting === false);
        }, { threshold: 0 }).observe(carousel);
      }

      render();
      sync();
    });
  }

  function initConditionals() {
    var form = document.getElementById('lt-book-form');
    if (!form) return;
    var checks = form.querySelectorAll('input[data-lt-service]');
    var serializedServices = form.querySelector('[name="contact[Services]"]');
    var groups = form.querySelectorAll('[data-visibility-dependency="x_services"]');
    function update() {
      var selected = Array.prototype.map.call(checks, function (check) { return check.checked ? check.value : ''; }).filter(Boolean);
      syncServices(selected);
      groups.forEach(function (group) {
        var values = (group.dataset.visibilityValues || '').split('|').filter(Boolean);
        var show = values.some(function (value) { return selected.indexOf(value) !== -1; });
        group.hidden = !show;
        group.setAttribute('aria-hidden', show ? 'false' : 'true');
        group.querySelectorAll('input, select, textarea').forEach(function (field) { field.disabled = !show; });
      });
    }
    function syncServices(selected) {
      if (serializedServices) serializedServices.value = selected.join(', ');
    }
    checks.forEach(function (check) { check.addEventListener('change', update); });
    update();
    // Native validation cannot focus a required field inside a collapsed
    // details element. Reopen its section during the capture-phase invalid
    // event so the browser can focus and announce the field normally.
    form.addEventListener('invalid', function (event) {
      var section = event.target.closest && event.target.closest('details.lt-book__section');
      if (section) section.open = true;
    }, true);
    form.addEventListener('submit', function (event) {
      var trap = form.querySelector('[name="contact[Website]"]');
      if (trap && trap.value) event.preventDefault();
    });
  }

  function init() { initCarousels(); initConditionals(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
